import messages from 'containers/SiteMapPage/messages';
import { PRIVILEGES } from 'utils/globalConst';
import pages from 'routes/pages';
import {
  setAutoDetailsPageBreadcrumbsPath,
  setEpargnDetailsPageBreadcrumbsPath,
  setMrhDetailsPageBreadcrumbsPath,
} from 'store/global/actions';
import { CONTACT_US_LINK } from 'constants/externalLinks';

const data = [
  {
    title: messages.auto_home,
    link: pages.AUTODASHBOARD,
    univers: PRIVILEGES.AUTO,
    isExternalLink: false,
  },
  {
    title: messages.auto_sinisters,
    link: pages.AUTO_DETAILS,
    univers: PRIVILEGES.AUTO,
    payload: setAutoDetailsPageBreadcrumbsPath([
      {
        name: 'auto',
        route: pages.AUTODASHBOARD,
      },
      {
        name: 'suiviDeSinistre',
      },
    ]),
    isExternalLink: false,
  },
  {
    title: messages.auto_contracts_and_guarantees,
    link: pages.AUTO_DETAILS,
    payload: setAutoDetailsPageBreadcrumbsPath([
      {
        name: 'auto',
        route: pages.AUTODASHBOARD,
      },
      {
        name: 'contractEtGarantie',
      },
    ]),
    univers: PRIVILEGES.AUTO,
    isExternalLink: false,
  },
  {
    title: messages.auto_services,
    link: pages.SERVICES,
    univers: PRIVILEGES.AUTO,
    isExternalLink: false,
  },
  {
    title: messages.auto_checkAuto,
    link: '',
    univers: PRIVILEGES.AUTO,
    isExternalLink: false,
  },
  {
    title: messages.auto_garage,
    link: '',
    univers: PRIVILEGES.AUTO,
    isExternalLink: false,
  },
  {
    title: messages.auto_contact_agent,
    link: '',
    univers: PRIVILEGES.AUTO,
    isExternalLink: false,
  },
  {
    title: messages.others_faq,
    link: pages.FAQ,
    public: true,
    isExternalLink: false,
  },
  {
    title: messages.others_contact,
    link: CONTACT_US_LINK,
    public: true,
    isExternalLink: true,
  },
  {
    title: messages.others_contact_utils,
    link: pages.CONTACTS,
    public: true,
    isExternalLink: false,
  },
  {
    title: messages.others_offers_and_tips,
    link: pages.OFFRES,
    public: true,
    isExternalLink: false,
  },
  {
    title: messages.others_services,
    link: pages.SERVICES,
    public: true,
    isExternalLink: false,
  },
  {
    title: messages.others_legal_mentions,
    link: pages.LEGAL_NOTICE,
    public: true,
    isExternalLink: false,
  },
  {
    title: messages.others_lexique,
    link: pages.LEXIQUE,
    public: true,
    isExternalLink: false,
  },
  // feature is planned in V1
  // {
  //   title: messages.others_cookies,
  //   link: pages.COOKIES,
  //   public: true,
  //   isExternalLink: false,
  // },
  {
    title: messages.habitation_home,
    link: pages.MRHDASHBOARD,
    univers: PRIVILEGES.MRH,
    isExternalLink: false,
  },
  {
    title: messages.habitation_sinistre,
    link: pages.MRH_DETAILS,
    univers: PRIVILEGES.MRH,
    payload: setMrhDetailsPageBreadcrumbsPath([
      {
        name: 'habitation',
        route: pages.MRHDASHBOARD,
      },
      {
        name: 'suiviDeSinistre',
      },
    ]),
    isExternalLink: false,
  },
  {
    title: messages.habitation_contracts_and_guarantees,
    link: pages.MRH_DETAILS,
    univers: PRIVILEGES.MRH,
    payload: setMrhDetailsPageBreadcrumbsPath([
      {
        name: 'habitation',
        route: pages.MRHDASHBOARD,
      },
      {
        name: 'contractEtGarantie',
      },
    ]),
    isExternalLink: false,
  },
  {
    title: messages.habitation_contact_agent,
    link: pages.MRH_DETAILS,
    univers: PRIVILEGES.MRH,
    isExternalLink: false,
  },
  {
    title: messages.saving_home,
    link: pages.EPARGN_DASHBOARD,
    univers: PRIVILEGES.EPARGN,
    isExternalLink: false,
  },
  {
    title: messages.saving_contracts,
    link: pages.EPARGN_DETAILS,
    univers: PRIVILEGES.EPARGN,
    payload: setEpargnDetailsPageBreadcrumbsPath([
      {
        name: 'epargn',
        route: pages.EPARGN_DASHBOARD,
      },
      {
        name: 'mesContrats',
      },
    ]),
    isExternalLink: false,
  },
  {
    title: messages.saving_situation,
    link: pages.EPARGN_DETAILS,
    univers: PRIVILEGES.EPARGN,
    payload: setEpargnDetailsPageBreadcrumbsPath([
      {
        name: 'epargn',
        route: pages.EPARGN_DASHBOARD,
      },
      {
        name: 'mesReleveDeSituation',
      },
    ]),
    isExternalLink: false,
  },
];

export default data;
